<template>
  <div>
    <div class="nav-placeholder-footer"></div>
    <b-navbar type="dark" variant="dark" fixed="bottom" class="pl-2 pr-2 pl-sm-3 pr-sm-3 pt-0 pb-0">
      <b-nav-text> &copy; {{ currentYear }} poi-hub.com </b-nav-text>

      <b-navbar-nav v-if="false" class="navbar-nav ml-auto" data-cy="navFooterRight">
        <b-nav-item v-if="user.loggedIn" :to="{ name: 'terms' }" class="pl-1 pr-1 pl-sm-2 pr-sm-2">
          Terms<span class="d-none d-sm-inline"> of Use</span>
        </b-nav-item>
        <b-nav-item v-if="user.loggedIn" :to="{ name: 'privacy' }" class="pl-1 pr-1 pl-sm-2 pr-sm-2">
          Privacy<span class="d-none d-sm-inline"> Policy</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'contact' }" class="pl-1 pr-1 pl-sm-2 pr-sm-2">
          Contact
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'nav-footer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear().toString(),
    };
  },
};
</script>

<style scoped>
.nav-placeholder-footer {
  height: 40px;
}
</style>
